import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact = () => {
  const [status, setStatus] = useState('idle'); // idle, submitting, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const formData = new FormData(e.target);
    
    try {
      const response = await fetch("https://formsubmit.co/ajax/bl.performancee@gmail.com", {
        method: "POST",
        headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            nome: formData.get("name"),
            email: formData.get("email"),
            messaggio: formData.get("message"),
            _subject: `Nuova richiesta da BL.Performance: ${formData.get("name")}`,
        })
      });

      if (response.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error("Errore nell'invio:", error);
      setStatus('error');
    }
  };

  return (
    <section id="contatti" className="py-32 bg-black relative">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-gold-500 uppercase tracking-[0.4em] text-xs font-black mb-6">Contatti</h2>
          <h3 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tighter uppercase leading-none">
            INIZIA ORA IL <br/> <span className="text-gray-700 italic">TUO CAMBIAMENTO.</span>
          </h3>
          <p className="text-gray-400 font-bold text-lg max-w-2xl mx-auto tracking-tight">
            Hai domande sui percorsi o vuoi prenotare una call conoscitiva? 
            Compila il modulo e ti risponderò personalmente.
          </p>
        </motion.div>

        {/* Form Section */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="bg-dark-900 p-8 md:p-12 border border-white/5 mb-16 shadow-2xl"
        >
          {status === 'success' ? (
            <div className="text-center py-20">
              <SafeIcon icon={FiIcons.FiCheck} className="w-16 h-16 text-gold-500 mx-auto mb-6" />
              <h4 className="text-white font-black text-3xl uppercase tracking-tighter">Richiesta Inviata!</h4>
              <p className="text-gray-400 mt-4 font-bold">Riceverai una risposta al più presto.</p>
              <button 
                onClick={() => setStatus('idle')}
                className="mt-8 text-gold-500 uppercase text-xs font-black tracking-widest hover:text-white transition-colors"
              >
                Invia un altro messaggio
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <input 
                  name="name"
                  type="text" 
                  required 
                  placeholder="NOME E COGNOME" 
                  className="w-full bg-black border border-white/10 px-6 py-5 text-white font-black uppercase tracking-widest text-xs focus:border-gold-500 outline-none transition-all" 
                />
                <input 
                  name="email"
                  type="email" 
                  required 
                  placeholder="EMAIL" 
                  className="w-full bg-black border border-white/10 px-6 py-5 text-white font-black uppercase tracking-widest text-xs focus:border-gold-500 outline-none transition-all" 
                />
              </div>
              <textarea 
                name="message"
                required 
                placeholder="IL TUO OBIETTIVO O DOMANDA" 
                rows="4" 
                className="w-full bg-black border border-white/10 px-6 py-5 text-white font-black uppercase tracking-widest text-xs focus:border-gold-500 outline-none transition-all resize-none" 
              ></textarea>
              
              <button 
                type="submit" 
                disabled={status === 'submitting'}
                className="w-full bg-white text-black font-black uppercase tracking-widest py-5 hover:bg-gold-500 transition-all duration-300 disabled:opacity-50 flex items-center justify-center space-x-3"
              >
                {status === 'submitting' ? (
                  <>
                    <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                    <span>Invio in corso...</span>
                  </>
                ) : 'Invia Richiesta'}
              </button>

              {status === 'error' && (
                <p className="text-red-500 text-xs font-black uppercase tracking-widest text-center">
                  Si è verificato un errore. Riprova più tardi o scrivimi direttamente.
                </p>
              )}
            </form>
          )}
        </motion.div>

        {/* Direct Contact Info */}
        <motion.div 
          initial={{ opacity: 0 }} 
          whileInView={{ opacity: 1 }} 
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-8 border-t border-white/5 pt-16"
        >
          <a href="mailto:bl.performancee@gmail.com" className="flex items-center space-x-6 group cursor-pointer">
            <div className="w-14 h-14 bg-dark-900 border border-white/10 flex items-center justify-center text-gold-500 group-hover:bg-gold-500 group-hover:text-black transition-all duration-300">
              <SafeIcon icon={FiIcons.FiMail} className="w-6 h-6" />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gray-600 font-black mb-1">Scrivimi</p>
              <p className="text-white font-black text-lg tracking-tight">bl.performancee@gmail.com</p>
            </div>
          </a>

          <a href="https://wa.me/393669994487" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-6 group cursor-pointer">
            <div className="w-14 h-14 bg-dark-900 border border-white/10 flex items-center justify-center text-gold-500 group-hover:bg-gold-500 group-hover:text-black transition-all duration-300">
              <SafeIcon icon={FiIcons.FiMessageSquare} className="w-6 h-6" />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gray-600 font-black mb-1">WhatsApp</p>
              <p className="text-white font-black text-lg tracking-tight">+39 366 999 4487</p>
            </div>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;